/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  CreateEmailSectionTagDto,
  DeletedResponseDto,
  EmailSectionTagListResponseDto,
  EmailSectionTagResponseDto,
  UpdateEmailSectionTagDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List email section tags
 */
export const adminEmailSectionTaxonomyControllerListTags = (
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailSectionTagListResponseDto>(
    { url: `/api/v1/admin/email-section-taxonomy/tags`, method: 'GET', signal },
    options
  );
};

export const getAdminEmailSectionTaxonomyControllerListTagsQueryKey = () => {
  return [`/api/v1/admin/email-section-taxonomy/tags`] as const;
};

export const getAdminEmailSectionTaxonomyControllerListTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof authFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminEmailSectionTaxonomyControllerListTagsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>
  > = ({ signal }) => adminEmailSectionTaxonomyControllerListTags(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminEmailSectionTaxonomyControllerListTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>
>;
export type AdminEmailSectionTaxonomyControllerListTagsQueryError = unknown;

export function useAdminEmailSectionTaxonomyControllerListTags<
  TData = Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
          TError,
          Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEmailSectionTaxonomyControllerListTags<
  TData = Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
          TError,
          Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEmailSectionTaxonomyControllerListTags<
  TData = Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List email section tags
 */

export function useAdminEmailSectionTaxonomyControllerListTags<
  TData = Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerListTags>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getAdminEmailSectionTaxonomyControllerListTagsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new email section tag
 */
export const adminEmailSectionTaxonomyControllerCreateTag = (
  createEmailSectionTagDto: CreateEmailSectionTagDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<EmailSectionTagResponseDto>(
    {
      url: `/api/v1/admin/email-section-taxonomy/tags`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createEmailSectionTagDto,
      signal,
    },
    options
  );
};

export const getAdminEmailSectionTaxonomyControllerCreateTagMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerCreateTag>>,
    TError,
    { data: CreateEmailSectionTagDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerCreateTag>>,
  TError,
  { data: CreateEmailSectionTagDto },
  TContext
> => {
  const mutationKey = ['adminEmailSectionTaxonomyControllerCreateTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerCreateTag>>,
    { data: CreateEmailSectionTagDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminEmailSectionTaxonomyControllerCreateTag(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEmailSectionTaxonomyControllerCreateTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerCreateTag>>
>;
export type AdminEmailSectionTaxonomyControllerCreateTagMutationBody = CreateEmailSectionTagDto;
export type AdminEmailSectionTaxonomyControllerCreateTagMutationError = unknown;

/**
 * @summary Create a new email section tag
 */
export const useAdminEmailSectionTaxonomyControllerCreateTag = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerCreateTag>>,
      TError,
      { data: CreateEmailSectionTagDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerCreateTag>>,
  TError,
  { data: CreateEmailSectionTagDto },
  TContext
> => {
  const mutationOptions = getAdminEmailSectionTaxonomyControllerCreateTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update an email section tag
 */
export const adminEmailSectionTaxonomyControllerUpdateTag = (
  id: string,
  updateEmailSectionTagDto: UpdateEmailSectionTagDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<EmailSectionTagResponseDto>(
    {
      url: `/api/v1/admin/email-section-taxonomy/tags/${id}`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: updateEmailSectionTagDto,
    },
    options
  );
};

export const getAdminEmailSectionTaxonomyControllerUpdateTagMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerUpdateTag>>,
    TError,
    { id: string; data: UpdateEmailSectionTagDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerUpdateTag>>,
  TError,
  { id: string; data: UpdateEmailSectionTagDto },
  TContext
> => {
  const mutationKey = ['adminEmailSectionTaxonomyControllerUpdateTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerUpdateTag>>,
    { id: string; data: UpdateEmailSectionTagDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminEmailSectionTaxonomyControllerUpdateTag(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEmailSectionTaxonomyControllerUpdateTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerUpdateTag>>
>;
export type AdminEmailSectionTaxonomyControllerUpdateTagMutationBody = UpdateEmailSectionTagDto;
export type AdminEmailSectionTaxonomyControllerUpdateTagMutationError = unknown;

/**
 * @summary Update an email section tag
 */
export const useAdminEmailSectionTaxonomyControllerUpdateTag = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerUpdateTag>>,
      TError,
      { id: string; data: UpdateEmailSectionTagDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerUpdateTag>>,
  TError,
  { id: string; data: UpdateEmailSectionTagDto },
  TContext
> => {
  const mutationOptions = getAdminEmailSectionTaxonomyControllerUpdateTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Delete an email section tag
 */
export const adminEmailSectionTaxonomyControllerRemoveTag = (
  id: string,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<DeletedResponseDto>(
    { url: `/api/v1/admin/email-section-taxonomy/tags/${id}`, method: 'DELETE' },
    options
  );
};

export const getAdminEmailSectionTaxonomyControllerRemoveTagMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerRemoveTag>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerRemoveTag>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminEmailSectionTaxonomyControllerRemoveTag'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerRemoveTag>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminEmailSectionTaxonomyControllerRemoveTag(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEmailSectionTaxonomyControllerRemoveTagMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerRemoveTag>>
>;

export type AdminEmailSectionTaxonomyControllerRemoveTagMutationError = unknown;

/**
 * @summary Delete an email section tag
 */
export const useAdminEmailSectionTaxonomyControllerRemoveTag = <
  TError = unknown,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerRemoveTag>>,
      TError,
      { id: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof adminEmailSectionTaxonomyControllerRemoveTag>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = getAdminEmailSectionTaxonomyControllerRemoveTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
